import { Clear } from '@mui/icons-material';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Slide,
  styled,
  Box,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React from 'react';

const CustomDialog = styled(Dialog)(() => ({
  '& .MuiDialogContent-root': {
    padding: '16px',
  },
  '& .MuiDialogActions-root': {
    padding: '16px',
  },
}));
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

function ORMModal({
  open = false,
  title,
  content,
  handlePrimaryButton = () => {},
  handleSecondaryButton = () => {},
  onClose = () => {},
  secondaryButtonName,
  primaryButtonName,
  disabledPrimaryButton = false,
  maxWidth = 'md',
  fullScreen = false,
  subtitle,
  ...rest
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const effectiveFullScreen = fullScreen || isMobile;

  return (
    <CustomDialog
      open={open}
      fullWidth
      maxWidth={maxWidth}
      fullScreen={effectiveFullScreen}
      slotProps={{
        paper: {
          style: {
            overflowY: effectiveFullScreen ? 'auto' : 'visible',
          },
        },
      }}
      onClose={onClose}
      slots={{
        transition: Transition,
      }}
      {...rest}
    >
      <DialogTitle sx={{ m: 0, p: 2, pr: 6, wordBreak: 'break-word' }}>
        {title}
        {subtitle && (
          <Box sx={{ mt: 0.5 }}>
            {React.isValidElement(subtitle) ? (
              subtitle
            ) : (
              <Typography
                variant='subtitle2'
                sx={{
                  color: 'text.secondary',
                }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
        )}
      </DialogTitle>
      <IconButton
        aria-label='close'
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
        }}
        data-testid='close-icon-btn'
      >
        <Clear />
      </IconButton>
      <Divider />
      <DialogContent dividers sx={{ px: { xs: 1.5, sm: 2 }, overflowX: 'auto' }}>
        {content}
      </DialogContent>
      {(secondaryButtonName || primaryButtonName) && (
        <DialogActions
          sx={{
            flexDirection: { xs: 'column-reverse', sm: 'row' },
            alignItems: 'stretch',
            justifyContent: { xs: 'stretch', sm: 'flex-end' },
            rowGap: { xs: 1, sm: 0 },
            columnGap: { xs: 0, sm: 1 },
            '& .MuiButton-root': {
              width: { xs: '100%', sm: 'auto' },
              ml: '0 !important',
              mr: '0 !important',
            },
          }}
        >
          {secondaryButtonName && (
            <Button data-testid='secondary-btn' onClick={handleSecondaryButton} variant='outlined' fullWidth={isMobile}>
              {secondaryButtonName}
            </Button>
          )}
          {primaryButtonName && (
            <Button
              data-testid='primary-btn'
              onClick={handlePrimaryButton}
              disabled={disabledPrimaryButton}
              fullWidth={isMobile}
            >
              {primaryButtonName}
            </Button>
          )}
        </DialogActions>
      )}
    </CustomDialog>
  );
}

export default ORMModal;
